module.exports = __webpack_public_path__ + "img/logo.dfaad41d.png";